module.exports = __webpack_public_path__ + "img/crossed-fingers.c57c91b6.png";